import { PageRef } from 'providers/page-ref';

export enum HomeTab {
  DailyLog = 'daily-log',
  Progress = 'progress'
}

export type HomeSlot = 'daylog-A' | 'daylog-B' | 'progress';

export type HomePageParams = {
  day?: string;
  tab?: HomeTab;
};

export const IHomePage: PageRef<HomePageParams, void> = {
  pageName: 'HomePage',
} as PageRef<HomePageParams, void>;
